import { useIsMobile } from "@/hooks/use-mobile";
import { Header } from "@/components/Header";
import { ServiceLink } from "@/components/service-share/ServiceLink";
import { SocialShareButtons } from "@/components/service-share/SocialShareButtons";
import { QRCodeDisplay } from "@/components/service-share/QRCodeDisplay";
import { ServiceShareHeader } from "@/components/service-share/ServiceShareHeader";
import { useServiceShare } from "@/components/service-share/useServiceShare";
import { MetaTags } from '@/components/shared/MetaTags';

const ServiceShare = () => {
  const isMobile = useIsMobile();
  const {
    navigate,
    businessName,
    profileBio,
    profileImageUrl,
    bannerImageUrl,
    qrCodeUrl,
    isSavingLink,
    getFullUrl,
    shareOnSocial,
    handleDownloadStyledQR
  } = useServiceShare();

  // Create a description using bio if available, otherwise use a default
  const description = profileBio || `Services provided by ${businessName}`;
  
  // Use banner image first, then profile image, then default image
  const imageUrl = bannerImageUrl || profileImageUrl || "/lovable-uploads/f3752283-ff9d-4cc9-b3c2-b633673f0e58.png";

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white">
      <MetaTags
        title={businessName}
        description={description}
        imageUrl={imageUrl}
        url={getFullUrl()}
        siteName={businessName}
      />
      
      <Header />
      <div className="container mx-auto px-4 py-24 max-w-2xl">
        <ServiceShareHeader 
          isSavingLink={isSavingLink}
          onNavigateToDashboard={() => navigate("/dashboard")}
        />
        
        <ServiceLink getFullUrl={getFullUrl} isMobile={isMobile} />
        
        <SocialShareButtons shareOnSocial={shareOnSocial} />
        
        <QRCodeDisplay 
          businessName={businessName}
          qrCodeUrl={qrCodeUrl}
          handleDownloadStyledQR={handleDownloadStyledQR}
        />
      </div>
    </div>
  );
};

export default ServiceShare;
